import jwt_decode from 'jwt-decode';
import Cookies from 'js-cookie';

export const getUserData = () => {
  const userToken = Cookies.get('SESSION_TOKEN');
  const userData = userToken ? jwt_decode(userToken) : null;
  return userData;
};
